import { render } from "./ssqdan.vue?vue&type=template&id=328338db&scoped=true"
import script from "./ssqdan.vue?vue&type=script&lang=js"
export * from "./ssqdan.vue?vue&type=script&lang=js"

import "./ssqdan.vue?vue&type=style&index=0&id=328338db&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-328338db"]])

export default __exports__